import { IProjectBuilder, IProjectBuilderOptions } from '../types';

import { createProjectBuilder } from '../generator/ProjectBuilder';

import esmodule from '../plugins/common/esmodule';
import containerClass from '../plugins/component/reactccs/containerClass';
import containerInitState from '../plugins/component/reactccs/containerInitState';
import containerInjectContext from '../plugins/component/reactccs/containerInjectContext';
import containerInjectUtils from '../plugins/component/reactccs/containerInjectUtils';
import containerInjectDataSourceEngine from '../plugins/component/reactccs/containerInjectDataSourceEngine';
import containerInjectI18n from '../plugins/component/reactccs/containerInjectI18n';
import containerLifeCycle from '../plugins/component/reactccs/containerLifeCycle';
import containerMethod from '../plugins/component/reactccs/containerMethod';
import jsx from '../plugins/component/reactccs/jsx';
import reactCommonDeps from '../plugins/component/reactccs/reactCommonDeps';
import css from '../plugins/component/style/css';
import constants from '../plugins/project/constants';
import i18n from '../plugins/project/i18n';
import utils from '../plugins/project/utils';

import icejsccs from '../plugins/project/framework/icejsccs';

import { prettier } from '../postprocessor';

export interface IceJsCcsProjectBuilderOptions extends IProjectBuilderOptions {}

export default function createIceJsCcsProjectBuilder(
  options?: IceJsCcsProjectBuilderOptions,
): IProjectBuilder {
  return createProjectBuilder({
    inStrictMode: options?.inStrictMode,
    extraContextData: { ...options },
    template: icejsccs.template,
    plugins: {
      components: [
        reactCommonDeps(),
        esmodule({
          fileType: 'jsx',
        }),
        containerClass(),
        containerInjectContext(),
        containerInjectUtils(),
        containerInjectDataSourceEngine(),
        containerInjectI18n(),
        containerInitState(),
        containerLifeCycle(),
        containerMethod(),
        jsx({
          nodeTypeMapping: {
            Div: 'div',
            Component: 'div',
            Page: 'div',
            Block: 'div',
          },
        }),
        css(),
      ],
      pages: [
        reactCommonDeps(),
        esmodule({
          fileType: 'jsx',
        }),
        containerClass(),
        containerInjectContext(),
        containerInjectUtils(),
        containerInjectDataSourceEngine(),
        containerInjectI18n(),
        containerInitState(),
        containerLifeCycle(),
        containerMethod(),
        jsx({
          nodeTypeMapping: {
            Div: 'div',
            Component: 'div',
            Page: 'div',
            Block: 'div',
            // Box: 'div',
          },
        }),
        css(),
      ],
      router: [esmodule(), icejsccs.plugins.router()],
      entry: [icejsccs.plugins.entry()],
      constants: [constants()],
      utils: [esmodule(), utils('react')],
      i18n: [i18n()],
      globalStyle: [icejsccs.plugins.globalStyle()],
      htmlEntry: [icejsccs.plugins.entryHtml()],
      packageJSON: [icejsccs.plugins.packageJSON()],
    },
    postProcessors: [prettier()],
  });
}

export const plugins = {
  containerClass,
  containerInitState,
  containerInjectContext,
  containerInjectUtils,
  containerInjectI18n,
  containerInjectDataSourceEngine,
  containerLifeCycle,
  containerMethod,
  jsx,
  commonDeps: reactCommonDeps,

  /** @deprecated Please use commonDeps */
  reactCommonDeps,
};
